import React from 'react';
import map from 'lodash/map';
import { LinkMainData, MainData, SubData } from './styled';

export const generateDatas = (data = []) =>
  map(data, (item, idx) =>
    idx > 0 ? (
      <SubData key={`sub_data_${idx}`}>{item.text}</SubData>
    ) : (
      <MainData key={`main_data_${idx}`}>{item.text}</MainData>
    )
  );

export const generateLinkDatas = (data = []) =>
  map(data, (item, idx) => {
    const { text, ...reset } = item;
    return idx > 0 ? (
      <SubData key={`sub_link_data_${idx}`}>{text}</SubData>
    ) : (
      <LinkMainData key={`link_data_${idx}`} {...reset}>
        {text}
      </LinkMainData>
    );
  });
